import axios from 'axios'


const instance = axios.create({
    baseURL:'http://localhost/sihan/public',
    timeout:3000
})

instance.interceptors.request.use(
    config => {
        
        return config
    },
    err => {
        console.log(err)
    }
)

instance.interceptors.response.use(
    response => {
        let res = {}
        res.status = response.status
        res.data = response.data
        return res
    },
    err => {
        console.log(err)
    }
)
export default instance